import Surrounding1 from '../Surrounding HI/BCA.webp'
import Surrounding2 from '../Surrounding HI/Courts.webp'
import Surrounding3 from '../Surrounding HI/Eka Hospital.webp'
import Surrounding4 from '../Surrounding HI/John Paul.webp'
import Surrounding5 from '../Surrounding HI/Living Plaza.webp'
import Surrounding6 from '../Surrounding HI/Sekolah Penabur.webp'
import Surrounding7 from '../Surrounding HI/Universitas Esa Unggul.webp'




const Surroundingimages =[
Surrounding1,Surrounding2,Surrounding3,Surrounding4,Surrounding5,Surrounding6,Surrounding7
]

export default Surroundingimages;